import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function AssignmentAmountModal({
  visible,
  itemName,
  maxQuantity,
  defaultQuantity,
  onConfirm,
  onCancel,
  zIndexBase = 1300,
}) {
  const [quantity, setQuantity] = useState(defaultQuantity);

  useEffect(() => {
    setQuantity(defaultQuantity);
  }, [defaultQuantity, visible]);

  if (!visible) return null;

  const safeQuantity = Math.max(1, Math.min(Number(quantity) || 1, maxQuantity));

  return createPortal(
    <div>
      <div
        onClick={onCancel}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(2, 10, 30, 0.78)",
          backdropFilter: "blur(4px)",
          zIndex: zIndexBase,
        }}
      />

      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: zIndexBase + 1,
          pointerEvents: "none",
        }}
      >
        <div
          onClick={(event) => event.stopPropagation()}
          style={{
            width: "min(420px, calc(100vw - 32px))",
            borderRadius: 18,
            background: "linear-gradient(160deg, rgba(10, 35, 70, 0.97) 0%, rgba(5, 20, 50, 0.98) 100%)",
            border: "1px solid rgba(80, 180, 255, 0.4)",
            boxShadow: "0 0 40px rgba(0, 150, 255, 0.25), 0 8px 24px rgba(0, 0, 0, 0.7)",
            padding: 24,
            color: "#e0f7fa",
            pointerEvents: "auto",
            boxSizing: "border-box",
          }}
        >
          <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 8, color: "#40e8ff" }}>
            Choose Amount
          </div>
          <div style={{ fontSize: 14, lineHeight: 1.5, color: "rgba(214, 232, 255, 0.84)", marginBottom: 16 }}>
            Choose how many of {itemName} to use.
          </div>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
            <span style={{ fontWeight: 700 }}>Amount</span>
            <span style={{ color: "#9be7ff", fontWeight: 700 }}>{safeQuantity} / {maxQuantity}</span>
          </div>

          <input
            type="range"
            min={1}
            max={maxQuantity}
            step={1}
            value={safeQuantity}
            onChange={(event) => setQuantity(Number(event.target.value))}
            style={{ width: "100%", marginBottom: 12, accentColor: "#5a9cff" }}
          />

          <input
            type="number"
            min={1}
            max={maxQuantity}
            step={1}
            value={safeQuantity}
            onChange={(event) => setQuantity(Number(event.target.value))}
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(0, 180, 216, 0.45)",
              background: "radial-gradient(circle at 10% 0%, rgba(5, 30, 70, 0.96), rgba(1, 10, 25, 0.96))",
              color: "#e0f7fa",
              fontSize: 14,
              marginBottom: 18,
            }}
          />

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button className="names-btn secondary" onClick={onCancel}>Cancel</button>
            <button className="names-btn primary" onClick={() => onConfirm(safeQuantity)}>Confirm</button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}